module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification",
    class: _vm.notification.cssClasses()
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.remove.apply(null, arguments)
      }
    }
  }), _c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text",
    on: {
      "click": _vm.navigate
    }
  }, [_vm._v(_vm._s(_vm.name) + " possui "), _c('span', [_c('span', {
    staticClass: "entity-type"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "entity-type"
  }, [_vm._v(_vm._s(_vm.contact_name))]), _vm._v(" "), _c('span', {
    staticClass: "entity-type"
  }, [_vm._v(_vm._s(_vm.flow_name))]), _vm._v(" agendada para " + _vm._s(_vm.due_on) + ".")])]), _c('div', {
    staticClass: "time",
    class: {
      left: _vm.table
    }
  }, [_vm._v(_vm._s(_vm.notification.timeText()))]), (!_vm.multiple_tasks && !_vm.done_task) ? _c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.show_do_task) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadTask(_vm.notification.kind)
      }
    }
  }, [_vm._v("Executar tarefa")])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.loadTask("mark_as_done")
      }
    }
  }, [_vm._v("Marcar como feita")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('div', {
    staticClass: "bullet"
  }), _c('div', {
    staticClass: "bullet"
  }), _c('div', {
    staticClass: "bullet"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1487201b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/kind/task.vue
// module id = 1017
// module chunks = 1